import { render, staticRenderFns } from "./ManagerStatistic.vue?vue&type=template&id=0db8eda2&scoped=true"
import script from "./ManagerStatistic.vue?vue&type=script&lang=ts"
export * from "./ManagerStatistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8eda2",
  null
  
)

export default component.exports